import React from 'react';
import { navigate } from 'gatsby';
import { Button } from '@codeparva/ui-components-library';
import { FontAwesomeIcon } from '../../../utilities/iconLoader/FontAwesomeIcon';
import { UserFlowTypes } from '../UserFlowTypes';
import { weakKey } from '../../../utilities/weakKey';
import RenderReservationUnitTypes from './reservationHelper';
import { accountSectionConfig } from '../components/accountConfig';

interface Props {
  account: UserFlowTypes.TAccountDetails;
  index?: number;
}

export const AccountDetails: React.FC<Props> = ({ account }) => {
  return (
    <div className="accountType">
      <h5 className="accountTypeMobile">{account.label}</h5>
      <label className="tag is-danger  alertAccountLabel subtitle2">
        {accountSectionConfig.paymentAlert}
      </label>
    </div>
  );
};

export const PaymentSection: React.FC<Props> = ({ account }) => {
  return (
    <div className="paymentSection">
      <UnitSection account={account} />
      {!!account.reservationDetails?.length && (
        <div className="reservationDividerAccount is-hidden-mobile"></div>
      )}
      {!!account.reservationDetails?.length && (
        <RenderReservationUnitTypes
          data={account.reservationDetails}
          id={account.id}
        />
      )}
    </div>
  );
};

export const ViewAccount: React.FC<Props> = ({ account, index }) => {
  return (
    <div className="buttonPosition">
      <Button
        data-testid={`account-selection-button-${index}`}
        className="cp-primary-button-highlighted buttonText"
        onClick={() => {
          navigate(`../${account.id}`, {
            replace: true,
          });
        }}
      >
        <span className="pr-3">{accountSectionConfig.buttonConfig}</span>
        <FontAwesomeIcon iconClassName="FaArrowRight"></FontAwesomeIcon>
      </Button>
    </div>
  );
};

const UnitSection: React.FC<Props> = ({ account }) => {
  return (
    <div className="paymentBalanceWrapper">
      <h5 className="paymentBalance">
        {accountSectionConfig.balance} {account.balance}
      </h5>
      <div className="unitSection">
        <h5 className="unitTypeList">
          <span className="unitConfig">{accountSectionConfig.unit}:</span>
          {!!account.unitDetails?.length ? (
            <RentedUnitDetails account={account} />
          ) : (
            <span>{accountSectionConfig.noUnitsAvailable}</span>
          )}
        </h5>
      </div>
    </div>
  );
};

const RentedUnitDetails: React.FC<Props> = ({ account }) => {
  const checkUnitCategory = (currCategoryArray: string[]) =>
    currCategoryArray.includes('Climate_Controlled') ? 'CC' : '';

  return (
    <>
      {account.unitDetails.length > 0 ? (
        account.unitDetails.map((unit: UserFlowTypes.TUnitList) => {
          return (
            <span key={weakKey({ unit })}>
              {`${unit.unitDetails.unitDescription} ${checkUnitCategory(
                unit.unitDetails.unitCategory
              )} (${unit.label})`}
            </span>
          );
        })
      ) : (
        <span>No Units Available</span>
      )}
    </>
  );
};
